define(["require", "exports", "tslib", "@arcgis/core/geometry/Point", "@arcgis/core/geometry/support/jsonUtils", "./SpatialReferenceFactory"], function (require, exports, tslib_1, Point_1, jsonUtils, SpatialReferenceFactory_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.GeometryFactory = void 0;
    Point_1 = tslib_1.__importDefault(Point_1);
    jsonUtils = tslib_1.__importStar(jsonUtils);
    class GeometryFactory {
        static toPolygon(rings, spatialReference = SpatialReferenceFactory_1.SpatialReferenceFactory.GDA_1994) {
            const g = {
                type: "polygon",
                rings,
                spatialReference
            };
            return jsonUtils.fromJSON(g);
        }
        static toPolyline(paths, spatialReference = SpatialReferenceFactory_1.SpatialReferenceFactory.GDA_1994) {
            const g = {
                type: "polyline",
                paths,
                spatialReference
            };
            return jsonUtils.fromJSON(g);
        }
        static toPoint(point, spatialReference = SpatialReferenceFactory_1.SpatialReferenceFactory.GDA_1994) {
            return new Point_1.default({ x: point.x, y: point.y, spatialReference });
        }
    }
    exports.GeometryFactory = GeometryFactory;
});
